import { assign, createMachine } from 'xstate';
import type { Modality } from '../types';

export interface SessionMachineContext {
  modality: Modality;
  trialIndex: number;
}

export type SessionMachineEvent =
  | { type: 'START'; modality: Modality }
  | { type: 'STIMULUS_READY' }
  | { type: 'ANSWER' }
  | { type: 'NEXT'; trialIndex: number }
  | { type: 'COMPLETE' }
  | { type: 'RESTART' };

export const sessionMachine = createMachine({
  types: {} as {
    context: SessionMachineContext;
    events: SessionMachineEvent;
  },
  id: 'limen-session',
  initial: 'idle',
  context: {
    modality: 'color',
    trialIndex: 0
  },
  on: {
    COMPLETE: { target: '.completed' }
  },
  states: {
    idle: {
      on: {
        START: {
          target: 'calibrating',
          actions: assign({
            modality: ({ event }) => event.modality,
            trialIndex: 0
          })
        }
      }
    },
    calibrating: {
      after: { 160: 'presenting' }
    },
    presenting: {
      on: { STIMULUS_READY: 'awaitingAnswer' }
    },
    awaitingAnswer: {
      on: { ANSWER: 'feedback' }
    },
    feedback: {
      on: {
        NEXT: {
          target: 'presenting',
          actions: assign({ trialIndex: ({ event }) => event.trialIndex })
        },
        COMPLETE: 'completed'
      }
    },
    completed: {
      on: { RESTART: 'idle' }
    }
  }
});
